import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

import data from '../data.json';
import DigitalPlatform from '../components/DigitalPlatform';
import Facilities from '../components/Facilities';
import ScrollUpBtn from '../components/ScrollUpBtn';
import ProductFeatures from '../components/ProductFeatures';
import Video2 from '../components/Video2';
import CustomerFocus from '../components/CustomerFocus';
import Clients1 from '../components/Clients1';
import Equipment1 from '../components/Equipment1';
import Review1 from '../components/Review1';
import Monitoring from '../components/Monitoring';
import SectionMainFigureImg from '../componentsVariant/SectionMainFigureImg';
import InfoBlock1 from '../components/InfoBlock1';
import { useScrollHandler } from '../utils/useScrollHandler';
import { useScrollContext } from '../store/ScrollContext';
import SectionMain from '../components/SectionMain';
import Blog from '../components/Blog';
import Header2 from '../components/Layout/Header';
import SmoothScrollWrapper from '../utils/SmoothScrollWrapper';
import DigitalPlatform1 from '../components/DigitalPlatform1';
import Blog1 from '../components/Blog1';
import { useResize } from '../utils/hooks';
import DigitalPlatformMobile from '../components/DigitalPlatformMobile';
import { isBY } from '../store/constants';
import Header from '../components/Layout/Header/Header';
import Footer from '../components/Layout/Footer';
import Awards from '../components/Awards';
import SectionDescktopWitsml from '../components/SectionWitsmlList/SectionDescktopWitsml';
import SectionMobileWitsml from '../components/SectionWitsmlList/SectionMobileWitsml';

export type LocationState = {
  scrollTo?: string;
};

function HomePage(): JSX.Element {
  //note: для многостраничной навигации
  const location = useLocation<LocationState>();
  const history = useHistory();
  //note: для мобильного возврата
  useEffect(() => {
    const scrollTo = sessionStorage.getItem('mobileScrollTo');
    if (scrollTo) {
      scroller.scrollTo(scrollTo, {
        duration: 800,
        smooth: true,
        offset: -20,
      });
      sessionStorage.removeItem('mobileScrollTo');
    }
  }, []);

  const { isScreen1024 } = useResize();

  return (
    <>
      <Header />
      <SmoothScrollWrapper>
        <>
          {/* <Header2 /> */}
          <ScrollUpBtn />
          <SectionMain />
          {isScreen1024 ? <DigitalPlatform1 /> : <DigitalPlatformMobile />}
          {isScreen1024 ? <SectionDescktopWitsml /> : <SectionMobileWitsml />}
          {!isBY && <Video2 />}
          <>
            <CustomerFocus />
          </>
          {/* <Awards /> */}
          {!isBY && <Review1 />}
          {/* <Blog /> */}
          {!isBY && <Blog1 />}
          <Footer dark />
        </>
      </SmoothScrollWrapper>
    </>
  );
}

export default HomePage;
